import { useMemo } from "react"
import queryString from "query-string"
import { useParams, useLocation, useNavigate } from "react-router-dom"

const STANDS = {
    LOCAL: "localhost",
    DEV: "dev",
}

export const useRouter = () => {
    const params = useParams<{ [key: string]: string | undefined }>()
    const location = useLocation()
    const navigate = useNavigate()
    const { host } = document.location

    return useMemo(() => {
        const push = (path: string, state?: unknown) =>
            navigate(path, state !== undefined ? { state } : undefined)
        const replace = (path: string, state?: unknown) =>
            navigate(path, { replace: true, ...(state !== undefined ? { state } : {}) })

        return {
            push,
            replace,
            pathname: location.pathname,
            query: {
                ...queryString.parse(location.search),
                ...params,
            },
            params,
            location,
            history: { push, replace },
            host,
            isDev: host.includes(STANDS.LOCAL) || host.includes(STANDS.DEV),
        }
    }, [navigate, location, params, host])
}
